import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import { SqoFile } from '@/common';
import env from '@/env';

export const addFileToTeamMember = async ({ id, formData }: { id: string; formData: FormData }) => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/sqo-team/${id}/documents`,
    { method: 'POST', body: formData }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as SqoFile;
  return response;
};
